import { useEffect } from 'react'

const VIEWPORT_CONTENT =
  'width=device-width, initial-scale=1, viewport-fit=cover'

/**
 * Garantiza que exista la meta viewport correcta.
 * Sin ella, Safari en iOS renderiza la página a 980px y escala el resultado,
 * lo que deforma y estira los widgets fijos como el chat de Tawk.to.
 */
export function useViewportMeta(): void {
  useEffect(() => {
    let meta = document.querySelector<HTMLMetaElement>(
      'meta[name="viewport"]',
    )

    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'viewport'
      document.head.appendChild(meta)
    }

    if (meta.content !== VIEWPORT_CONTENT) {
      meta.content = VIEWPORT_CONTENT
    }
  }, [])
}
